import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class PublicDictionaryProductAttributeResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly label!: string;
}
